import React from 'react';
import styled from '@emotion/styled';
import Page from '../../../components/Page/Page';
import ApplicationSegment from './ApplicationSegment';
import PageBanner from '../../../components/Banner/PageBanner';

const Applications = () => {
  return (
    <Page title="Locum Health | Applications on your Jobs">
      <Container>
        <PageBanner
          label="Applications"
          description="Manage Applications here"
        />
        <ApplicationSegment />
      </Container>
    </Page>
  );
};

export default Applications;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;

  @media (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
